module.exports = __webpack_public_path__ + "img/icon_2R.a630bd24.svg";